import { Form as AntForm } from 'antd';
import styled from 'styled-components';

export const Form = styled(AntForm)`
  &.transaction-mail-form {
    .mail-form-item {
      height: 100%;
      overflow-y: auto;
      /* grown by the halo's reach so a focused field's ring is not clipped, and by the
         scrollbar's strip so the cards keep the same space on both sides */
      scrollbar-gutter: stable;
      margin-inline: -3px calc(-3px - var(--scrollbar-width));
      padding-inline: 3px;
      .ant-form-item-row {
        height: 100%;
        .ant-form-item-control {
          height: 100%;
          .ant-form-item-control-input {
            height: 100%;
            .ant-form-item-control-input-content {
              height: 100%;
            }
          }
        }
      }
    }
  }
`;
